import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  titleSection: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    textAlign: 'center',
  },
  iconButton: {
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.button.default,
    '@media (hover: none) and (pointer: coarse)': {
      minWidth: theme.spacing(5.5),
      minHeight: theme.spacing(5.5),
    },
  },
  icon: {
    fontSize: 14,
    color: theme.palette.common.black,
  },
}));

type setionItemProps = {
  children?: React.ReactNode;
  title: string;
  onClickIcon?: () => void
  additionalButton?: React.ReactNode;
  icon?: IconProp
  // Accessible name for the icon button; defaults to "Add <title>".
  iconLabel?: string;
}

const SectionItemTitle: FC<setionItemProps> = ({
  children,
  title,
  onClickIcon,
  additionalButton,
  icon,
  iconLabel,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item className={classes.header}>
        <Typography className={classes.titleSection} variant="body1" component="h3">{title}</Typography>
        {onClickIcon && (
          <IconButton
            aria-label={iconLabel || `${t('common:add')} ${title}`}
            className={classes.iconButton}
            onClick={(e) => {
              e.stopPropagation();
              onClickIcon?.();
            }}
            size="large"
          >
            <FontAwesomeIcon icon={icon || 'plus'} className={classes.icon} />
          </IconButton>
        )}
        {additionalButton}
      </Grid>
      <Grid item>
        {children}
      </Grid>
    </Grid>
  );
};

export default SectionItemTitle;
